import {
  createBrowserRouter,
  isRouteErrorResponse,
  Link,
  Navigate,
  useRouteError,
} from "react-router-dom";
import App from "@/App";
import { AuthProvider } from "@/components/providers/auth-provider";
import AppLayout from "@/components/layout/app-layout";
import LoginPage from "@/pages/login";
import ProyectosPage from "@/pages/proyectos";
import ProyectoDetailPage from "@/pages/proyecto-detail";
import UsoPage from "@/pages/uso";

function RouteError() {
  const error = useRouteError();
  const is404 = isRouteErrorResponse(error) && error.status === 404;

  return (
    <div className="flex min-h-screen items-center justify-center bg-surface-100">
      <div className="text-center space-y-4">
        <h1 className="text-6xl font-bold text-line-faint">
          {is404 ? "404" : "Error"}
        </h1>
        <h2 className="text-xl font-semibold text-ink">
          {is404 ? "Página no encontrada" : "Algo salió mal"}
        </h2>
        <p className="text-sm text-content-muted max-w-md">
          {is404
            ? "La página que buscas no existe o fue movida."
            : "Ha ocurrido un error inesperado."}
        </p>
        <Link
          to="/proyectos"
          className="inline-block mt-4 px-6 py-2 bg-brand text-white rounded hover:bg-brand-hover transition-colors"
        >
          Volver al inicio
        </Link>
      </div>
    </div>
  );
}

function NotFoundPage() {
  return (
    <div className="flex flex-1 items-center justify-center py-24">
      <div className="text-center space-y-4">
        <h1 className="text-6xl font-bold text-line-faint">404</h1>
        <h2 className="text-xl font-semibold text-ink">
          Página no encontrada
        </h2>
        <p className="text-sm text-content-muted max-w-md">
          La página que buscas no existe o fue movida.
        </p>
        <Link
          to="/proyectos"
          className="inline-block mt-4 px-6 py-2 bg-brand text-white rounded hover:bg-brand-hover transition-colors"
        >
          Volver al inicio
        </Link>
      </div>
    </div>
  );
}

export const router = createBrowserRouter([
  {
    element: <App />,
    errorElement: <RouteError />,
    children: [
      {
        path: "/login",
        element: <LoginPage />,
      },
      {
        element: (
          <AuthProvider>
            <AppLayout />
          </AuthProvider>
        ),
        children: [
          { index: true, element: <Navigate to="/proyectos" replace /> },
          { path: "proyectos", element: <ProyectosPage /> },
          { path: "proyectos/:id", element: <ProyectoDetailPage /> },
          { path: "uso", element: <UsoPage /> },
          { path: "*", element: <NotFoundPage /> },
        ],
      },
    ],
  },
]);
